<template>
  <div ref="handleBtns">
    <component
      class="handle-btn-items"
      :key="index"
      v-for="(handle, index) in handleList"
      :is="getHandleType(handle.shape) + 'HandleBtns'"
      :handle="handle"
      :ids="ids"
      :shape="shape"
      @mouseenterHandle="mouseenterHandle($event, handle, index)"
      @mouseleaveHandle="mouseleaveHandle($event, handle, index)"
      @openLayoutComponentEdit="openLayoutComponentEdit(handle.shape, handle, index)"
      @del="del"
      :index="index"
      :isCanDel="isCanDelStatu(index)"
      :isClone="isClone"
      :isDrawer="isDrawer"
      :isPopover="isPopover"
      @clone="clone"
      :showComponentName="showComponentName"
      @openBox="openBox"
      :options="options"
    />
  </div>
</template>

<script>
import rectHandleBtns from "./handleBtns/rectHandleBtns"
import colHandleBtns from "./handleBtns/colHandleBtns"
import pageHandleBtns from "./handleBtns/pageHandleBtns"
import pageLayoutHandleBtns from "./handleBtns/pageLayoutHandleBtns"
import pageLayoutCellHandleBtns from "./handleBtns/pageLayoutCellHandleBtns"
import $ from "jquery"
import { isExist } from "../../utils"
export default {
  name: "handleBtnGroups",
  props: {
    handleList: {
      type: Array
    },
    ids: {
      type: Object
    },
    handleType: {
      type: String,
      default: "rect"
    },
    isCanDel: {
      type: Boolean
    },
    enabled: {
      type: Boolean,
      default: true
    },
    isClone: {
      type: Boolean
    },
    //判断该选中部分的所有工具栏都集中在这里
    isAllHandleBtns: true,
    // 是否禁止操作元素
    forbiden: {
      type: Boolean,
      default: false
    },
    shape:{
      type:String
    },
    options:{
      type: Object
    },
    isActive:{
      type:Boolean
    }
  },
  components: { rectHandleBtns, colHandleBtns, pageHandleBtns, pageLayoutHandleBtns, pageLayoutCellHandleBtns },
  data: function () {
    return {
      name: "",
      iconClass: "",
      currentElment: {},
      isDrawer: false,
      isPopover: false,
      isGoTop: false
    }
  },
  watch: {
    isActive(n,o){
      if(!n){
        $(this.$el).find(".handle-btn-items").removeClass("displayBlock")
      }
    },
    handleList(n, o) {
      console.log("handleList")
      if (n && n != o && n.length > 0) {
        let isTop = false
        if ($(this.$el).hasClass("is_top") || $(this.$el).hasClass("bottom-bottom")) {
          isTop = true
        }
        let firstLevel = isTop ? 0 : this.handleList.length - 1
        this.currentElment = n[firstLevel]

        if (this.currentElment.shape === "cxButton") {
          // 按钮组件分为两种，一种是普通按钮，一种是抽屉按钮
          let rectAttr = this.getAttrById(
            this.$store.state[this.request_prefix],
            this.currentElment.ids
          )
          let options = rectAttr.options ? rectAttr.options : rectAttr
          const isDrawer = options.pluginName?.includes("drawerPlugin")
          const isPopover = options.pluginName?.includes("popoverPlugin")
          const isGoTop = options.pluginName?.includes("goTopPlugin")
          this.currentElment.name = isDrawer ? "抽屉按钮" : isPopover ? "弹出框按钮" : isGoTop ? "回到顶部按钮" : this.currentElment.name ? this.currentElment.name : "按钮"
          this.isDrawer = isDrawer
          this.isPopover = isPopover
          this.isGoTop = isGoTop
        }
        // 特殊处理，针对handleList中抽屉存在的时候，需要去掉布局这层数据
        if (this.handleList.find(it => it.name === "抽屉") && this.handleList.find(it => it.name === "布局")) {
          this.$emit("removeLayout")
        }
        if (this.isGoTop && this.handleList.find(it => it.name === "布局" || it.name === "通栏")) {
          this.$emit("removeLayout")
        }
        if(this.handleList.find(it => it.name === "弹出框") && this.handleList.find(it => it.shape === "cxPageLayoutCell")) {
          this.$emit("removeLayout")
        }
        if (this.currentElment.shape === "swiperComponent" || this.currentElment.shape === "emptyLayoutComponent") {
          this.currentElment.ids = {
            container_id: n[firstLevel].ids.container_id,
            rect_id: n[firstLevel].ids.rect_id,
            elementInAutoLayoutId: n[firstLevel].ids.elementInAutoLayoutId,
            path: n[firstLevel].ids.path,
          }
        }
          // 翻转之后数据改变 类名会丢失
          if ($(this.$el).find(".handle-btn-items.displayBlock").length > 0) {
            this.$nextTick(()=>{
              $(this.$el).find(".handle-btn-items").addClass("displayBlock")
            })
          }
      }
    }
  },
  methods: {
    isCanDelStatu(index) {
      // 根据工具栏显示的位置（上方，下方）判断哪个层级需要展示删除
      let isDelete = false
      if ($(this.$el).hasClass("top-bottom") || $(this.$el).hasClass("bottom-bottom")) {
        isDelete = true
      }
      // 栅格刚拖拽后，没有el对象，默认可以删除
      let firstLevel = isDelete || !this.$el ? 0 : this.handleList.length - 1
      return this.isCanDel && index === firstLevel ? true : false
    },
    getHandleType(shape) {
      let type
      switch (shape) {
        case "colsComponent":
          // 单元格
          type = "col"
          break
        case "cxPageLayoutCell":
          // 布局
          type = "pageLayoutCell"
          break
        case "cxPageLayout":
          // 通栏
          type = "pageLayout"
          break
        case "page":
          // 页面
          type = "page"
          break
        default:
          // 组件
          type = "rect"
      }
      return type
    },
    // 获取父级的dom元素
    getParentNode(handleInfo) {
      let parentNode
      switch (handleInfo.shape) {
        case "colsComponent":
          parentNode = $(`#${handleInfo.ids.uid}`)
          break
        case "cxPageLayoutCell":
          parentNode =
            handleInfo.ids.pageLayoutId.length === 1
              ? $(`.pageLayout_id_${handleInfo.ids.pageLayoutId}`)
              : $(`#layout_${handleInfo.ids.pageLayoutId}`)
          break
        case "cxPageLayoutComponentCell":
          parentNode =
            handleInfo.ids.pageLayoutId.length === 1
              ? $(`.pageLayout_id_${handleInfo.ids.pageLayoutId}`)
              : $(`#rect_id_${handleInfo.ids.rect_id}_layout_${handleInfo.ids.pageLayoutId}`)
          break
        case "cxPageLayout":
          let pageLayoutIndex =handleInfo.ids.pageLayoutId
          // 需要考虑通栏 isShow 为false的情况
          let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
          let hideLen = 0
          for(let i=0;i<pageLayoutList.length;i++){
            if(pageLayoutList[i].options.hasOwnProperty('isShow') && !pageLayoutList[i].options.isShow  ){
              hideLen++
            }
            if(pageLayoutIndex == i){
              pageLayoutIndex = i - hideLen
              break
            }
          }
          parentNode = $(`.page-layout-wrapper`).eq(pageLayoutIndex)
          break
        case "page":
          parentNode = $(`#container_${handleInfo.ids.container_id}`)
          break
        default:
          if (handleInfo.ids.uid) {
            parentNode = $(
              `.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}-uid_${handleInfo.ids.uid}-elementInLayoutId_${handleInfo.ids.elementInLayoutId}`
            )
          } else if (handleInfo.ids.elementInAutoLayoutId !== undefined) {
            parentNode = $(`.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}-elementInAutoLayoutId_${handleInfo.ids.elementInAutoLayoutId}-path_${handleInfo.ids.path ? handleInfo.ids.path.join('') : handleInfo.ids.path}`)
          } else {
            parentNode = $(`.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}`)
          }
      }
      return parentNode
    },
    mouseenterHandle(e, handleInfo, index) {
      let isTop = false
      if ($(this.$el).hasClass("is_top")) {
        isTop = true
      }
      if ((!isTop && handleInfo.ids === this.ids) || (isTop && index === 0 && this.isAllHandleBtns)) {
        return
      }
      let parentNode = this.getParentNode(handleInfo)
      if (parentNode) {
        parentNode.addClass("hover-active")
        if (handleInfo.shape === "cxPageLayout") {// 悬浮通栏不显示工具栏
          parentNode.addClass("handleHide")
        }
      }
    },
    mouseleaveHandle(e, handleInfo, index) {
      let isTop = false
      if ($(this.$el).hasClass("is_top")) {
        isTop = true
      }
      if ((!isTop && handleInfo.ids === this.ids) || (isTop && index === 0 && this.isAllHandleBtns)) {
        return
      }
      let parentNode = this.getParentNode(handleInfo)
      if (parentNode) {
        parentNode.removeClass("hover-active")
        if (handleInfo.shape === "cxPageLayout") {
          parentNode.removeClass("handleHide")
        }
      }
    },
    // 激活选中组件
    openLayoutComponentEdit(shape, handle, index) {
      let showRightToolbar = this.$store.state.states.showRightToolbar
      let activeID = this.$store.state.states.activeID
      if (this.forbiden) {
        return
      }
      if ($(this.$el).hasClass("is_top") && index === 0) {
        return
      } else if (!Object.keys(activeID).some(k => activeID[k] !== handle.ids[k]) && !Object.keys(handle.ids).some(k => activeID[k] !== handle.ids[k])) {
        return
      }
      let changeId
      if (handle.ids) changeId = handle.ids
      console.log("handle.ids",handle.ids)
      this.clearAllActiveInCol(changeId, shape)
      switch (handle.shape) {
        case "cxPageLayoutCell":
          // 当前被激活对象为布局时
          $(`#layout_${handle.ids.pageLayoutId}`).siblings(".layout-sets").find(".default-icon").click()
          break
        case "cxPageLayoutComponentCell":
          // 当前被激活对象为布局时
          $(`#rect_id_${handle.ids.rect_id}_layout_${handle.ids.pageLayoutId}`).siblings(".layout-sets").find(".default-icon").click()
          break
        case "cxPageLayoutComponent":
          $(".layout-container.set_active").removeClass("set_active active")
          this.$store.dispatch(this.request_prefix + "/setActive", handle.ids)
          break
        case "cxPageLayout":
          let pageLayoutIndex = handle.ids.pageLayoutId
          // 需要考虑通栏 isShow 为false的情况
          let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
          let hideLen = 0
          for(let i=0;i<pageLayoutList.length;i++){
            if(pageLayoutList[i].options.hasOwnProperty('isShow') && !pageLayoutList[i].options.isShow  ){
              hideLen++
            }
            if(pageLayoutIndex == i){
              pageLayoutIndex = i - hideLen
              break
            }
          }
          if (handle.name === "抽屉") {
            $(`.pageLayout_id_${pageLayoutIndex}`).find(".padding-block-top").click()
          } else if(handle.name === "弹出框") {
            const sourceIds = this.$store.state[this.request_prefix].page.pageLayoutList[handle.ids.pageLayoutId].options.sourceIds
            this.$store.commit("states/changeActiveID", sourceIds)
            this.$store.commit("states/changeElementType", "cxButton")
            return
          } else {
            $(`.page-layout-wrapper`).eq(pageLayoutIndex).find(".padding-block-top").click()
          }
          break
        default:
          if (isExist(this.ids?.elementInAutoLayoutId) && isExist(this.options?.elementInAutoLayoutId)) {
            let ids = {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
            }
            if (isExist(this.ids.elementInLayoutId)) {
              ids = {
                container_id: this.ids.container_id,
                rect_id: this.ids.rect_id,
                elementInLayoutId: this.ids.elementInLayoutId,
                uid: this.ids.uid
              }
            }
            this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", ids)
          }
          this.$store.commit("states/changeElementType", shape)
          this.$store.commit("states/changeActiveID", changeId)
          let rect = null
          try {
            rect = this.getAttrById(
              this.$store.state[this.request_prefix],
              changeId,
              "rect"
            )
          } catch (error) { }
          if (changeId && rect) {
            this.$store.dispatch(this.request_prefix + "/setActive", changeId)
          }
          if (shape === "cxPageLayoutComponent") {// 通栏组件
            this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
              ...changeId
            })
          }
          if (shape === "emptyLayoutComponent") {
            // 此方法会导致再次将自由布局active设为true
            if (changeId.elementInAutoLayoutId !== undefined) {
              this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutActive", changeId)
            } else {
              this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
                ...changeId
              })
            }
          }
          // 设置单元格的activeCol 不然当有三层以上单元格时会一直悬浮前一个单元格
          if (shape === "colsComponent") {
            this.$changeOptionsEV(changeId.uid, "activeCol", false, null, {
              container_id: changeId.container_id,
              rect_id: changeId.rect_id
            })
          }
          if (handle.shape === "cxAutoLayout") {
            if (changeId.elementInLayoutId !== undefined) {// 选中自由布局下的自动布局
              this.$store.dispatch(this.request_prefix + "/changeLayoutActive", {
                ...changeId,
                option_name: "isActive",
                option_val: true
              })
            } else if (changeId.elementInAutoLayoutId !== undefined) {// 自动布局中的自动布局
              this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutActive", changeId)
            } else {
              this.$store.dispatch(this.request_prefix + "/setActive", changeId)
            }
          } else if (changeId.elementInAutoLayoutId !== undefined) {
            this.$store.dispatch(this.request_prefix + "/unsetActive", {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
            })
          } else if (changeId.directionIndex !== undefined) {
            this.$store.dispatch(this.request_prefix + "/changeLayoutTitleActive", changeId)
          } else if (changeId.elementInLayoutId !== undefined) {
            let delAllTitleActive = {
              container_id: changeId.container_id,
              rect_id: changeId.rect_id,
              elementInAutoLayoutId: changeId.elementInAutoLayoutId,
              path: changeId.path,
            }
            // 取消侧边栏元素选中效果
            this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
            let param = {
              ...changeId,
              option_name: "isActive",
              option_val: "delAllActive"
            }
            // 取消单元格其他元素选中
            this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
            // 激活当前元素
            this.$store.dispatch(this.request_prefix + "/changeLayoutActive", {
              ...changeId,
              option_name: "isActive",
              option_val: true
            })
          }
      }
      // 点击取消悬浮态
      let parentNode = this.getParentNode(handle)
      if (parentNode) {
        parentNode.removeClass("hover-active")
      }

        // 当切换组件 把其他组件的展开菜单关闭
      let displayBlock = $(this.$el).find(".handle-btn-items.displayBlock")
      this.$nextTick(() => {
        if (displayBlock.length > 0) {
          displayBlock.removeClass("displayBlock")
        }
      })
      showRightToolbar ? this.$store.commit("states/changeShowRightToolbarStatus", true) : ""
    },
    // 删除组件
    del() {
      this.$emit("delElement")
    },
    // 克隆组件
    clone() {
      this.$emit("cloneElement")
    },
    // 打开抽屉、弹出框
    openBox() {
      this.$emit("openBox", this.isDrawer ? "drawer" : "popover")
    },
    clearAllActiveInCol(ids, shape) {
      //当前单元格中有激活组件时 在进行清除激活操作
      if (isExist(this.ids.directionIndex)) {
        let disableActiveLayoutTitle = {
          ...this.ids
        }
        this.$store.dispatch(this.request_prefix + "/layoutTitleDisableActive", disableActiveLayoutTitle)
      }

      if (shape === "colsComponent" || shape === "emptyLayoutComponent") {
        let param = {
          ...ids,
          option_name: "isActive",
          option_val: "delAllActive"
        }
        this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
      } else if (shape === "swiperComponent") {
        // 清除轮播内组件激活状态
        let param = {
          ...ids,
          swiperContent_id: this.ids.swiperContent_id,
          elementInSwiperId: null
        }
        if (param.hasOwnProperty("swiperContent_id") && isExist(param.swiperContent_id)) {
          this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", param)
        }
        // 设置轮播激活状态 用于清除上一个选中组件的active
        this.$store.dispatch(this.request_prefix + "/setActive", {
          container_id: ids.container_id,
          rect_id: ids.rect_id
        })
      } else if(isExist(this.ids.rect_id)){
        this.$store.commit(this.request_prefix + "/DISABLE_ACTIVE", {
          ...this.ids
        })
      }
    }
  },
  computed: {
    showComponentName() {
      return this.$store.state.states.showComponentName
    },
  }
}
</script>
<style lang="scss">
/*待后续统一*/
/* 通栏布局保持之前的阴影 */
.hover-active {
  outline : 1px dashed var(--themeColor)!important;
  & > .handle-tb,
  & > .handle-rb,
  & > .handle-bb,
  & > .handle-lb {
    display: block !important; // 用于组件如果设置了背景或者边框 上面的阴影设置不生效
  }
}
.select-active.hover-active,
.vdr.hover-active {
  outline: none !important;
}
</style>
<style scoped>
.new-btn-groups {
  margin-top: 0px;
}
/* 显示在元素内侧顶部 */
::v-deep .new-btn-groups.is_top {
  margin-top: 0;
}
::v-deep.new-btn-groups .handle-icon-box:hover {
  background: none;
}
::v-deep.new-btn-groups .handle-icon-box:not(:first-child) {
  outline: 1px solid rgba(255, 255, 255, 0.4);
}
::v-deep.new-btn-groups .icon {
  width: 16px;
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
}
.new-btn-groups .hover-set-groups {
  background: transparent;
  color: var(--themeColorHover);
  text-align: left;
  display: none;
}
::v-deep.new-btn-groups .hover-set-groups .icon {
  color: var(--themeColorHover);
}
.vdr.active > .new-btn-groups > .hover-set-groups {
  display: none !important;
}
.vdr.vdr_hover .new-btn-groups > .hover-set-groups {
  display: block;
}
.handle-btn-items {
  display: none;
  margin-bottom: 2px;
}
</style>
